import { zonedTimeToUtc } from 'date-fns-tz';
import { calendarParts, fromCalendarDate, addCivilDays } from './calendarSystem';

export function quickCalendarOccurrences(date, time, recurrence, count, calendar, timezone) {
  if (!Number.isInteger(count) || count < 1 || count > 52) throw new Error('Choose 1–52 appointments.');
  const anchor = calendarParts(date, calendar);
  const months = calendar === 'ethiopic' ? 13 : 12;
  const result = [];
  for (let index = 0; result.length < count && index < count * 8 + 12; index++) {
    let day = date;
    if (recurrence === 'month' || recurrence === 'year') {
      const offset = anchor.year * months + anchor.month - 1 + index * (recurrence === 'year' ? months : 1);
      try { day = fromCalendarDate(Math.floor(offset / months), offset % months + 1, anchor.day, calendar); }
      catch { continue; } // Skip nonexistent dates, including Pagume 6 in a common year.
    } else if (recurrence === 'day' || recurrence === 'week') {
      day = addCivilDays(date, index * (recurrence === 'week' ? 7 : 1));
    } else if (index > 0) break;
    result.push(zonedTimeToUtc(`${day}T${time}:00`, timezone).toISOString());
  }
  if (result.length !== count) throw new Error('Could not generate all appointment dates.');
  return result;
}
